// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { dashboardBuilder16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-dashboard-builder': IconDashboardBuilder;
    }
}

/**
 * The icon component for the 'dashboardBuilder' icon
 */
export class IconDashboardBuilder extends Icon {
    public constructor() {
        super(dashboardBuilder16X16);
    }
}

registerIcon('icon-dashboard-builder', IconDashboardBuilder);
export const iconDashboardBuilderTag = 'nimble-icon-dashboard-builder';
